import { connectSearchBox } from 'instantsearch.js/es/connectors'
import { getPageId, getAllIngredientValues, getSearchInputValue  } from './../../../../algolia/helper';

const renderSearchBox = (renderOptions, isFirstRender) => {
    const { refine, widgetParams } = renderOptions;
    const { traduction } = widgetParams;
  
    if (!isFirstRender) {
        return;
    }

    widgetParams.container.innerHTML = getTemplate(traduction);

    /**
     * Ajoute d'un ingrédient
     */
    $('#ok-btn').on('click', function (e) {
        e.preventDefault();
        let maxIngredients = 10;
        
        // récupère l'ingrédient saisis
        let ingredient = $('#multi-ingredients-input').val();

        // Si il n'y a pas d'ingrédient saisis ou que le nombre d'ingrédients déjà saisis est au maximum, ignorer
        if(ingredient.length === 0 || getAllIngredientValues().length >= maxIngredients) {
            return;
        }

        // Ajoute le nouvel ingrédients
        $('.wrapper').append(
            `<span class="custom-filter">${ingredient}</span>`
        );

        // Lance la recherche et sauvegarde Algolia
        refine(getSearchInputValue() + " " + getAllIngredientValues().join(' '));
        //saveCookieIngredient();

        // Si le maximum d'ingrédient est atteints, passe le bouton en disabled
        if(getAllIngredientValues().length === maxIngredients){
            $(this).attr('disabled', true);
        }

        // Vide l'input de saisis après ajout de l'ingrédients
        $('#multi-ingredients-input').val("");
    });

    /**
     * Ajout d'un ingrédient avec la touche "entré" du clavier
     */
    $('#multi-ingredients-input').on('keyup', function (e) {
        if (e.key === 'Enter') {
            $('#ok-btn').click();
        }
    })

    /**
     * Suppression d'un ingrédient en cliquant dessus
     */
    $('.wrapper').on('click', '.custom-filter', function(e) {
        e.preventDefault();
        $(this).remove();

        refine(getSearchInputValue() + " " + getAllIngredientValues().join(' '));
        //saveCookieIngredient();

        $('#ok-btn').attr('disabled', false);
    });

    /**
     * Au clic sur le bouton d'ajout d'un ingredient
     */
    $('.add-btn').click(function (e) {
        e.preventDefault();
        // Affiche le champ d'ajout des ingrédients
        $('#multi-ingredients-box').removeAttr('hidden');
        $(this).attr('hidden', true);
        $('.hide-btn').removeAttr('hidden');
    });

    /**
     * Au clic sur le bouton pour masquer le champ
     */
    $('.hide-btn').click(function (e) {
        e.preventDefault();
        // Cache le champ d'ajout des ingrédients
        $('#multi-ingredients-box').attr('hidden', true);
        $(this).attr('hidden', true);
        $('.add-btn').removeAttr('hidden');

    });

    let ingredients = getCookieIngredients();
    if(ingredients) {
        ingredients.split('||').forEach((ingredient) => {
            $('.wrapper').append(`<span class="custom-filter">${ingredient}</span>`)
        })
    }

};

/**
 * Sauvegarde le cookie qui est utilisé rééafficher le contenu des ingrédients précédement selectionné lors d'un changement de page
 */
function saveCookieIngredient()
{
    const cookieValue = `recette_ingredient_${getPageId()}=${getAllIngredientValues().join('||')}; SameSite=Strict`;
    document.cookie = cookieValue;
}

function getCookieIngredients()
{
    return $.cookie(`recette_ingredient_${getPageId()}`);
}

/**
 * retourne le template de la searchBoxIngrédient
 * @param {object} traduction, object js contenant les traductions
 */
function getTemplate(traduction)
{
    let ingredients = getCookieIngredients();

    return `<div
        id="header_ingredients"
        class="filtres-header"
        data-toggle="collapse"
        data-target="#content_ingredients"
        aria-expanded="true"
        aria-controls="content_ingredients"
    >
        <div class="filtres-header-interne">${traduction.title}</div>
    </div>
    <div id="content_ingredients" class="filtres-content collapse show">
        <div class="filtres-content-interne">
            <label class="add-btn ais-refinement-list--label">
                ${traduction.label}
            </label>
            <label class="hide-btn ais-refinement-list--label" hidden>
                ${traduction.inputHide}
            </label>
                <div class="ais-search-box" id="multi-ingredients-box" hidden>
                    <input
                        id="multi-ingredients-input"
                        autocapitalize="off"
                        autocomplete="off" 
                        autocorrect="off"
                        type="text"
                        value="" 
                        name="input_name_ingredient[]" 
                        class ="ais-search-box--input"
                        placeholder="Rechercher un ingrédient" 
                        role="textbox"
                        aria-label="${traduction.label}"
                    >
                    <button 
                        class="btn btn-primary" 
                        id="ok-btn"
                        *$
                        ${ingredients && ingredients.split('||').length > 10 ? 'disabled' : ''}
                    >
                    ${traduction.input}
                    </button>
                </div>
                <div
                    class="ais-search-box"
                    hidden
                    >
                    <input
                        id="multi-ingredients-hidden"
                        type="text"
                        value="" 
                        name="input_name[]" 
                        class ="ais-search-box--input"
                        disabled
                    >
                </div>
            <div class="wrapper"></div>
        </div>
    </div>`;
}

const searchBoxIngredient = connectSearchBox(renderSearchBox);

export default searchBoxIngredient;